import { render, staticRenderFns } from "./creatInstructions.vue?vue&type=template&id=48179e5a&scoped=true"
import script from "./creatInstructions.vue?vue&type=script&lang=js"
export * from "./creatInstructions.vue?vue&type=script&lang=js"
import style0 from "./creatInstructions.vue?vue&type=style&index=0&id=48179e5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48179e5a",
  null
  
)

export default component.exports